import { Component } from '@angular/core';
import { ProjectDetailsServiceService } from '../project-details-service.service';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { UtilsService } from '../services/utils.service';
import { isValidPhoneNumber } from '../phone-validator';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';


@Component({
    selector: 'app-project-contact-us',
    imports: [ReactiveFormsModule,NgSelectModule,CommonModule],
    templateUrl: './project-contact-us.component.html',
    styleUrl: './project-contact-us.component.scss'
})
export class ProjectContactUsComponent {
  public createForm:any;
  public isFormSubmitted:boolean = false;
  public isDataSubmitted:boolean=false;
 constructor(public projectDetailsService:ProjectDetailsServiceService,public utils:UtilsService){

 }

 ngOnInit(): void {
  this.createForm=new FormGroup({
    name:new FormControl('',[Validators.required]),
    email:new FormControl('',[Validators.required,Validators.email]),
    phoneNumber:new FormControl('',[Validators.required,this.phoneNumberValidator.bind(this)]),
    code:new FormControl('+971',[Validators.required]),
    userType:new FormControl('',[Validators.required]),
    message:new FormControl('',[Validators.required]),
    projectId:new FormControl(null)
  })
 }

 get f(){
  return this.createForm.controls;
}


 formatPhoneNumber() {
    let phoneNumber = this.createForm.get('phoneNumber')?.value.replace(/\D/g, ''); // Remove non-digits
    this.createForm.get('phoneNumber')?.setValue(phoneNumber, { emitEvent: false });
    this.validatePhoneNumber();
  }

  // Handle country code change
  onCountryCodeChange() {
    this.validatePhoneNumber();
  }

  // Validate the complete phone number
  validatePhoneNumber() {
    const phoneControl = this.createForm.get('phoneNumber');
    if (phoneControl) {
      phoneControl.updateValueAndValidity();
    }
  }

  // Custom phone number validator
  phoneNumberValidator(control: any) {
    const countryCode = this.createForm?.get('code')?.value;
    const phoneNumber = control.value;

    if (!countryCode || !phoneNumber) {
      return null; // Let required validator handle this
    }
    // Find country by dial code
    const country = this.utils.countries.find((c: any) => c.dialCode === countryCode);
    if (!country) {
      return { invalidPhone: true };
    }
    // Combine code and number
    const fullNumber = countryCode + phoneNumber;
    // Validate using libphonenumber
    if (!isValidPhoneNumber(fullNumber, country.code)) {
      return { invalidPhone: true };
    }

    return null;
  }

  // Set phone as invalid (if needed elsewhere)
  setPhoneInvalid() {
    this.createForm.get('phoneNumber')?.setErrors({ invalidPhone: true });
  }

 createContact(){
  this.isDataSubmitted=true;
  if(this.createForm.valid){
    this.isDataSubmitted=false;
    this.utils.spinner.show();
    this.createForm.patchValue({
      projectId:this.projectDetailsService.selectedProject?.project?.id,
    })
    this.projectDetailsService.dataService.createContact(this.createForm.value).subscribe({
      next:(x:any)=>{
      this.utils.spinner.hide();
      this.utils.toaster.success('Message submitted success.')
      this.createForm.reset();
      this.createForm.patchValue({
        message:'',
        code:'+971',
        userType:'',

      })
      },
      error:(err:any)=>{
        this.utils.spinner.hide();
      }
    })
  }
 }
}
